<template>
  <!-- ini adalah card untuk kelas yang harus diselesaikan -->
  <v-card class="mx-auto" max-width="400" v-if="type == 'enroll'" style="height: 100%">
    <div>
      <v-img
        contain
        class="white--text align-end"
        height="200px"
        :src="item.cover ? item.cover : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-success.jpg'"
      ></v-img>
      <div v-if="item.is_publik" :class="item.progress.status ? 'arrow-left-green' : 'arrow-left-red'"></div>
      <div v-if="item.is_publik" :class="item.progress.status ? 'label-green' : 'label-red'">
        {{ item.progress.status ? "Selesai" : "Wajib" }}
      </div>

      <div
        v-if="!item.is_publik && item.jenis.tag !== 'cadangan'"
        :class="
          item.status_pelaksanaan === 2
            ? 'arrow-left-orange'
            : item.progress.status
            ? 'arrow-left-green'
            : $tools.checkKelasRunningST(item.server_time, item)
            ? 'arrow-left-blue'
            : 'arrow-left-red'
        "
      ></div>
      <div
        v-if="!item.is_publik && item.jenis.tag !== 'cadangan'"
        :class="
          item.status_pelaksanaan === 2 ? 'label-orange' : item.progress.status ? 'label-green' : $tools.checkKelasRunningST(item.server_time, item) ? 'label-blue' : 'label-red'
        "
      >
        {{
          $tools.parseIsBefore(item.server_time, item.tanggal_mulai)
            ? "Belum dimulai"
            : item.status_pelaksanaan === 2
            ? "Dalam proses Sinkronisasi"
            : item.progress.status
            ? "Selesai"
            : $tools.checkKelasRunningST(item.server_time, item)
            ? "Sedang Berlangsung"
            : "Tidak Selesai"
        }}
      </div>
      <div class="caption primary--text text--lighten-4 text-right mr-2">{{ ukg }}</div>
    </div>

    <v-card-title v-if="item.is_publik" :class="item.is_publik ? 'primary--text  ma-0 py-0' : 'primary--text  ma-0 py-0'" style="word-break: break-word"
      >{{ pVal(item, "nama") }}
    </v-card-title>
    <v-card-title class="primary--text" style="word-break: break-word" v-else>
      <span
        >{{ title }} <span v-if="item.angkatan && item.jenis.tag !== 'cadangan'">({{ pVal(item, "angkatan") }})</span></span
      >
    </v-card-title>

    <v-card-subtitle v-if="!item.is_publik & (item.jenis.tag !== 'cadangan')" class="black--text caption py-4">
      <v-row no-gutters>
        <v-col cols="1">
          <v-icon size="15" color="primary">mdi-clock-outline</v-icon>
        </v-col>
        <v-col cols="11"
          >{{ pVal(item, "tanggal_mulai") | toDT }} <strong>s/d</strong><br />
          {{ pVal(item, "tanggal_selesai") | toDT }}
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-subtitle v-else>
      <!-- <v-icon size="15" color="primary">mdi-check</v-icon> -->
      <span class="black--text" v-if="!item.is_available">{{ item.keterangan }}</span>
      <div class="black--text my-2" v-else>{{ item.progress.status ? "&nbsp;" : item.keterangan }}</div>
    </v-card-subtitle>

    <v-card-text class="pb-0 text--primary">
      <v-progress-linear
        v-if="item.jenis.tag !== 'luring' && item.jenis.tag !== 'cadangan' && item.jenis.tag !== 'registrasi'"
        color="success"
        :value="item.progress.data.percentage"
      ></v-progress-linear>
      <div v-if="item.jenis.tag !== 'luring' && item.jenis.tag !== 'cadangan' && item.jenis.tag !== 'registrasi' && item.instansi_id != 55" align="right">
        {{ item.progress.data.percentage }}% selesai
      </div>
      <div v-else-if="item.jenis.tag !== 'cadangan'" align="right" class="pt-2">
        Completed: <span v-if="item.progress">{{ item.progress.data.completed }}/{{ item.progress.data.total }}</span
        ><span v-else>Dalam Proses</span>
      </div>
      <div class="py-4" v-else></div>
    </v-card-text>
    <v-card-actions v-if="pendaftaran.includes(item.jenis.tag)">
      <v-row>
        <v-col cols="12" v-if="item.is_publik">
          <m-button
            isBlock
            :disabled="item.is_available == 0"
            depressed
            :color="item.progress.status ? 'grey white--text' : 'primary'"
            :textButton="item.progress.status ? 'Tutup' : 'Mulai'"
            :action="item.progress.status ? '' : 'toCourse'"
            @toCourse="toCourse(item)"
          ></m-button>
        </v-col>
        <v-col cols="12" v-else>
          <m-button
            v-if="$tools.checkKelasRunningST(item.server_time, item)"
            :disabled="item.is_available == 0"
            isBlock
            depressed
            :color="item.status_pelaksanaan === 2 ? 'warning' : item.progress.status ? 'grey white--text' : 'success'"
            :textButton="item.progress.status ? 'Tutup' : 'Mulai'"
            action="toCourse"
            @toCourse="toCourse(item)"
          ></m-button>
          <m-button
            v-else-if="$tools.parseIsBefore(item.server_time, item.tanggal_selesai) && item.jenis.is_pindah"
            isBlock
            depressed
            color="primary"
            textButton="Ubah Jadwal"
            action="ubahJadwal"
            @ubahJadwal="ubahJadwal(item)"
          ></m-button>
          <m-button
            v-else-if="$tools.parseIsAfter(item.server_time, item.tanggal_selesai) && item.progress.status"
            isBlock
            depressed
            color="grey white--text"
            textButton="Tutup"
            action="toCourse"
          ></m-button>
          <m-button
            v-else
            isBlock
            depressed
            :color="isJadwalUlang ? 'error' : 'grey white--text'"
            :textButton="isJadwalUlang ? 'Gagal' : 'Belum Mulai'"
            :action="isJadwalUlang ? 'ubahJadwal' : ''"
            @ubahJadwal="ubahJadwal(item)"
          ></m-button>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-actions v-else-if="item.jenis.tag == 'extapp'">
      <v-row>
        <v-col cols="12">
          <m-button
            v-if="$tools.checkKelasRunningST(item.server_time, item)"
            :disabled="item.is_available == 0"
            isBlock
            depressed
            :color="item.progress.status ? 'grey white--text' : 'success'"
            :textButton="item.progress.status ? 'Tutup' : 'Mulai'"
            action="toCourse"
            @toCourse="toCourse(item)"
          ></m-button>
          <m-button
            v-else-if="$tools.parseIsBefore(item.server_time, item.tanggal_selesai) && item.jenis.is_pindah"
            isBlock
            depressed
            color="primary"
            textButton="Ubah Jadwal"
            action="ubahJadwal"
            @ubahJadwal="ubahJadwal(item)"
          ></m-button>
          <m-button
            v-else-if="$tools.parseIsAfter(item.server_time, item.tanggal_selesai) && item.progress.status"
            isBlock
            depressed
            color="grey white--text"
            textButton="Tutup"
            action="toCourse"
          ></m-button>
          <m-button
            v-else
            isBlock
            depressed
            :color="isJadwalUlang ? 'error' : 'grey white--text'"
            :textButton="isJadwalUlang ? 'Gagal' : 'Belum Mulai'"
            :action="isJadwalUlang ? 'ubahJadwal' : ''"
            @ubahJadwal="ubahJadwal(item)"
          ></m-button>
          <div class="pt-4" v-if="item.jenis.is_detail == 1">
            <m-button isBlock depressed color="warning" textButton="Detail Informasi" action="getExtApp" @getExtApp="getDetail(item)"></m-button>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-actions v-else-if="item.jenis.tag == 'video'">
      <v-row>
        <v-col cols="12">
          <m-button disabled isBlock depressed color="warning white--text" textButton="Ubah Tautan" action="toUpdateUrl" @toUpdateUrl="$emit('unggah', item)"></m-button>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-actions v-else-if="item.jenis.tag == 'survei'">
      <v-row>
        <v-col cols="12">
          <m-button isBlock depressed color="info white--text" textButton="Isi Refleksi Kesiapan IKM" action="toSurvei" @toSurvei="getLinkSurvei"></m-button>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-actions v-else>
      <v-row>
        <v-col cols="12" v-if="current_instansi.id == 55 && item.completed_by && item.is_complete == 0">
          <p class="px-4 mb-0 text-caption">Ajuan Anda ditolak silakan ajukan perbaikan data</p>
          <p class="px-4 mb-0 text-caption pt-1">Catatan:</p>
          <p class="px-4 pt-0 text-caption">{{ item.ke_keterangan }}</p>
        </v-col>
        <v-col cols="12" v-if="item.jenis.tag !== 'cadangan'">
          <m-button
            isBlock
            depressed
            :color="
              item.progress.status
                ? 'grey white--text'
                : current_instansi.id == 55 && item.completed_by && item.is_complete == 0
                ? 'warning'
                : current_instansi.id == 55 && item.completed_by && item.is_complete == 0
                ? 'success'
                : 'primary'
            "
            :textButton="
              current_instansi.id == 55
                ? item.completed_by && item.is_complete == 0
                  ? 'Ajukan Perbaikan'
                  : item.completed_by && item.is_complete == 1
                  ? 'Ajuan Diterima'
                  : 'Informasi'
                : 'Informasi'
            "
            action="info"
            @info="toInfo(item)"
          ></m-button>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
  <!-- ini adalah card untuk kelas yang bisa dipilih -->

  <v-card v-else-if="type == 'pilihJenis'">
    <div>
      <v-img
        contain
        class="white--text align-end"
        height="200px"
        :src="item.cover ? item.cover : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-success.jpg'"
      ></v-img>
      <div class="caption grey--text text--lighten-1 text-right mr-2 my-0 py-0">{{ ukg }}</div>
    </div>

    <v-card-title class="primary--text my-0 py-0" v-if="item.is_publik">{{ pVal(item, "nama") }}</v-card-title>
    <v-card-title class="primary--text my-0 py-0 ml-1" style="word-break: break-word" v-else
      >{{ title }} <span v-if="isangkatan">({{ pVal(item, "angkatan") }})</span>
    </v-card-title>

    <v-card-subtitle class="black--text" v-if="isModeKelas">
      <v-icon size="15" color="primary">mdi-clock-outline</v-icon>
      {{ pVal(item, "tanggal_mulai") | toD }} -
      {{ pVal(item, "tanggal_selesai") | toD }}
    </v-card-subtitle>

    <v-card-text v-if="!item.is_available" class="pb-0">
      <div v-if="item.is_kuota && cekKuota && false">
        <p class="title error--text my-0 py-0">
          {{ pVal(cekKuota, "angkatan") }}
          <v-chip color="orange white--text"
            >&nbsp;{{ cekKuota.kuota_tersedia }} Slot tersedia
            <v-progress-circular v-if="reloadKuota" color="white" class="ml-1" :size="15" :width="2" indeterminate></v-progress-circular>
          </v-chip>
        </p>
        <p class="caption black--text my-0 py-0">Pelaksanaan : <br />{{ cekKuota.tanggal_mulai | toD }} s/d {{ cekKuota.tanggal_selesai | toD }}</p>
        <p class="caption error--text mt-2">{{ current_instansi.diklat[0].keterangan }}</p>
      </div>
      <div v-if="!isSyarat" class="mx-2 pt-4">
        <v-row>
          <v-col class="mb-0 py-0 px-0" cols="1">
            <v-icon class="mt-n1" color="error">mdi-close</v-icon>
          </v-col>
          <v-col class="my-0 py-0 px-0 body-2" cols="11">
            <p>Akun Anda <strong>tidak memenuhi syarat</strong> untuk mengikuti seri ini. Silakan cek syarat dan ketentuan berikut:</p>
            <a class="body-1" :href="current_instansi.url_portal" target="_blank"><u>Syarat dan ketentuan</u></a>
            <p></p>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-expansion-panels accordion flat v-model="panel" multiple v-if="syarat.length > 0">
      <v-expansion-panel>
        <v-expansion-panel-header :class="isdisable ? 'font-weight-bold black--text red lighten-5 my-2 py-2 pl-4 ' : 'font-weight-bold black--text green lighten-4 my-2 py-2 pl-4'">
          <template>
            <span class="caption"><b>Prasyarat</b><br /><i>Klik disini untuk detail prasyarat lebih lanjut</i></span></template
          >
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mt-2 pt-3 pb-0">
          <v-row v-for="itemSyarat in syarat" :key="itemSyarat.index">
            <v-col class="mb-0 py-0 px-0" cols="1">
              <v-icon small class="mt-0" :color="itemSyarat.status ? 'success' : 'error'">{{ itemSyarat.status ? "mdi-check" : "mdi-close" }}</v-icon>
            </v-col>
            <v-col :class="itemSyarat.status ? `my-0 py-1 px-0 caption` : `my-0 py-1 px-0 caption grey--text`" cols="11">
              <div v-for="(info, i) in itemSyarat.hasil" :key="info.index">
                <span>{{ info.keterangan.text[0] }}</span>
                <span class="font-weight-bold" v-for="(value, index) in info.keterangan.include" :key="value.index">
                  {{ value }}
                  <span v-if="index !== info.keterangan.include.length - 1 && info.keterangan.include.length !== 1">/</span>
                </span>

                <span v-if="itemSyarat.hasil && itemSyarat.hasil.length > 1 && i != itemSyarat.hasil.length - 1">atau</span>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="my-4"></div>
    <v-row class="ml-2 mr-1 pt-0 pb-2" v-if="!item.is_selfenrol">
      <v-col class="mb-0 py-0" cols="1">
        <v-icon size="15" color="warning" v-if="current_instansi.diklat[0].keterangan">mdi-clock-outline</v-icon>
      </v-col>
      <v-col class="my-0 pt-0 body-2" cols="11">
        <span class="caption warning&#45;&#45;text"
          ><i>{{ current_instansi.diklat[0].keterangan }}</i></span
        >
      </v-col>
    </v-row>

    <v-card-actions v-if="item.is_selfenrol">
      <m-button v-if="$tools.parseIsAfter(item.server_time, item.tanggal_selesai)" class="my-2" :disabled="true" isBlock depressed color="primary" textButton="Daftar"></m-button>
      <m-button
        v-else
        class="my-2"
        :disabled="isdisable || current_instansi.is_tutup == 1"
        isBlock
        depressed
        color="primary"
        :textButton="
          !isSyarat
            ? 'Tidak tersedia'
            : this.pendaftaran.includes(item.tag)
            ? 'Daftar'
            : item.tag == 'autoenroll'
            ? 'Dalam Proses'
            : item.tag == 'survei'
            ? 'Isi Refleksi Kesiapan IKM'
            : 'Daftar'
        "
        action="pilih"
        @pilih="pilih(item)"
      ></m-button>
    </v-card-actions>
  </v-card>
  <span v-else></span>
</template>

<script>
import { PASSPORT } from "@/const";

// @group Global Component
export default {
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary"
    },
    isangkatan: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "pilih"
    },
    isJadwalUlang: {
      type: Boolean,
      default: false
    },
    isModeKelas: {
      type: Boolean,
      default: false
    },
    isdisable: {
      type: Boolean,
      default: true
    },
    angkatan: {
      type: String,
      default: ""
    },
    syarat: {
      type: Array,
      default: () => []
    },
    isSyarat: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      cekKuota: null,
      reloadKuota: false,
      t: false,
      panel: [0],
      pendaftaran: ["", "lms", "token"]
    };
  },
  mounted() {
    // load kuota hanya dilakukan jika tipe jenis kelasnya menggunakan pembatasan kuota (is_kuota = true)
    // dan pengguna yang akan enroll memenuhi semua syarat (isdisabled = false)
    if (this.item.is_kuota && !this.isdisable) {
      this.reloadKuota = true;
      this.getKuotaJenis();
    }
  },
  methods: {
    getKuotaJenis() {
      return this.$store
        .dispatch("kelas/getKuota", { instansi_id: this.instansi_id, obj: this.item })
        .then(res => {
          this.cekKuota = res;
          // courseWindow.location.href = PASSPORT + res;
        })
        .catch(() => (this.reloadKuota = false));
    },
    pilih(item) {
      this.reloadKuota = false;
      this.$emit("pilih", item);
    },
    toInfo(item) {
      this.$emit("info", item);
    },
    ubahJadwal(item) {
      this.reloadKuota = false;
      this.$emit("ubahJadwal", item);
    },

    getDetail(val) {
      return this.$store
        .dispatch("kelas/getDetailActivity", { params: { kelas_id: val.id, email: this.current_user.email } })
        .then(res => {
          const objDetail = {
            atribut: res,
            filterData: val.jenis.detail_atribut
          };
          this.$emit("detailActivity", objDetail);
        })
        .catch(e => e);
    },

    getLinkSurvei() {
      var courseWindow = window.open("", "_self");
      return this.$store
        .dispatch("kelas/getLinkSurvei", { instansi_id: this.instansi_id, params: { jenis_kelas_id: this.item.jenis.id } })
        .then(res => {
          this.instansi = res;
          if (res) {
            courseWindow.location.href = res[0].survei.url;
          } else {
            this.$error("Kuesioner tidak tersedia");
          }
        })
        .catch(e => e);
    },
    toCourse(val) {
      if (val.jenis.tag === "extapp") {
        this.getExtApp(val);
      } else if (val.jenis.tag === "survei") {
        this.getLinkSurvei();
      } else {
        var courseWindow = window.open("", "_blank");
        return this.$store
          .dispatch("kelas/getLearndash", val)
          .then(res => {
            courseWindow.location.href = PASSPORT + res;
          })
          .catch(e => {
            this.$info("Pantau Jadwal Pelaksanaan pembelajaran dihalaman beranda Anda");
            courseWindow.close();
            if (e.message === "Konten belum tersedia")
              this.$router.push({ name: "no-content", params: { seri: this.current_instansi.nama, angkatan: val.angkatan, state: val.status_pelaksanaan } });
          });
      }
    },
    getExtApp(val) {
      if (val.jenis.is_specific_url) {
        return this.$store
          .dispatch("kelas/getSpecificExt", { judul: val.keterangan })
          .then(res => {
            var extWindow = window.open("", "_blank");
            extWindow.location.href = res.tautan_tes;
          })
          .catch(e => e);
      } else {
        var extWindow = window.open("", "_blank");
        extWindow.location.href = val.url_kelas;
      }
    }
  },
  watch: {
    reloadKuota(val) {
      if (val && !this.t && this.item.is_kuota) {
        this.t = setInterval(() => {
          this.getKuotaJenis();
        }, 120000);
      } else {
        clearInterval(this.t);
      }
    },
    instansi_id() {
      this.reloadKuota = false;
    }
  }
};
</script>

<style>
.label-blue {
  background-color: #007bff;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.label-orange {
  background-color: #ff9800;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-orange {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid #f44336;
}

.arrow-left-blue {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid #007bff;
}

.label-red {
  background-color: #e61d4c;
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-red {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid rgb(170, 0, 0);
}

.label-green {
  background-color: rgb(61, 187, 82);
  color: white;
  top: 20px;
  left: -20px;
  position: absolute;
  padding: 5px 15px 5px 15px;
  text-align: left;
}

.arrow-left-green {
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  top: 33px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 20px solid rgb(10, 143, 54);
}

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 40px;
}
</style>
